import { useNavigate } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";
import { useBrief } from "@/context/BriefContext";
import { track } from "@/lib/analytics";
import { LEGAL_LINKS } from "@/lib/legalLinks";

export function Footer() {
  const { openBrief } = useBrief();
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer>
      {/* Deep Sage CTA band */}
      <section
        data-testid="site-footer-cta-band"
        className="on-sage bg-[#515E4F] text-[#F6F2EC]"
      >
        <div className="cv-container py-16">
          <div className="max-w-2xl">
            <p className="cv-sans uppercase tracking-[0.14em] text-xs text-[#F6F2EC]/70">
              Start where the pain is
            </p>
            <h2 className="cv-display-serif text-[#F6F2EC] mt-4 text-3xl sm:text-4xl">
              The decision is expensive. The call is yours.
            </h2>
            <p className="cv-body text-[#F6F2EC]/85 mt-5 max-w-xl">
              Start a Sprint today, or request the brief and we&rsquo;ll send the
              detail first. The next move is yours.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <button
                data-testid="footer-cta-button"
                className="cv-btn-primary"
                onClick={() => {
                  track("door_click", { target: "sprint", location: "footer" });
                  navigate("/services/founder-tech-clarity-sprint");
                }}
              >
                Start a Sprint
              </button>
              <button
                className="cv-btn-secondary text-[#F6F2EC] border-[rgba(246,242,236,0.35)] hover:bg-[#46523f] hover:border-[#F6F2EC]"
                onClick={() => {
                  track("door_click", { target: "brief_request", location: "footer" });
                  openBrief("general");
                }}
              >
                Request the brief
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Base footer */}
      <div className="bg-[#1F1B16] text-[#F6F2EC]">
        <div className="cv-container py-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <Wordmark tone="bone" />
          <div className="flex flex-col sm:items-end gap-3">
            <div className="flex gap-6">
              <a
                href={LEGAL_LINKS.privacy}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-privacy-link"
                className="cv-sans uppercase text-xs tracking-[0.12em] text-[#F6F2EC]/70 hover:text-[#F6F2EC] underline underline-offset-4 decoration-[rgba(246,242,236,0.3)]"
              >
                Privacy
              </a>
              <a
                href={LEGAL_LINKS.terms}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-terms-link"
                className="cv-sans uppercase text-xs tracking-[0.12em] text-[#F6F2EC]/70 hover:text-[#F6F2EC] underline underline-offset-4 decoration-[rgba(246,242,236,0.3)]"
              >
                Terms
              </a>
              <a
                href={LEGAL_LINKS.cookies}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-cookies-link"
                className="cv-sans uppercase text-xs tracking-[0.12em] text-[#F6F2EC]/70 hover:text-[#F6F2EC] underline underline-offset-4 decoration-[rgba(246,242,236,0.3)]"
              >
                Cookies
              </a>
              <a
                href="#"
                className="termly-display-preferences cv-sans uppercase text-xs tracking-[0.12em] text-[#F6F2EC]/70 hover:text-[#F6F2EC] underline underline-offset-4 decoration-[rgba(246,242,236,0.3)]"
                data-testid="footer-consent-preferences-link"
              >
                Consent Preferences
              </a>
            </div>
            <p className="cv-body text-xs text-[#F6F2EC]/50">
              &copy; {year} Copper and Vine. Founded 2003. coppervine.io
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
